import React, { useEffect, useState } from "react";
import { Table, Button, Input, Popconfirm, Space } from "antd";
import { IconPlus, IconPencil, IconTrash } from "@tabler/icons-react";
import { SearchOutlined } from "@ant-design/icons";
import PageHeader from "../../components/header/PageHeader";
import KeywordFormModal from "./KeywordFormModal";
import api from "../../api";
import { useToast } from "../../components/toast";

export default function Keywords() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const toast = useToast();

  const fetchList = async () => {
    setLoading(true);
    const res = await api.keywords_list();
    if (res?.status === 200) setData(res.data);
    else toast(res?.data?.message || "Алдаа гарлаа", "error");
    setLoading(false);
  };

  useEffect(() => {
    fetchList();
  }, []);

  const onDelete = async (id) => {
    const res = await api.keywords_remove(id);
    if (res?.status === 200) {
      toast("Устгагдлаа", "success");
      setData((prev) => prev.filter((k) => k.id !== id));
    } else {
      toast(res?.data?.message || "Алдаа гарлаа", "error");
    }
  };

  const filtered = (() => {
    const qq = q.trim().toLowerCase();
    if (!qq) return data;
    return data.filter(
      (k) =>
        k.key?.toLowerCase().includes(qq) ||
        k.label?.toLowerCase().includes(qq) ||
        k.value?.toLowerCase().includes(qq),
    );
  })();

  const columns = [
    {
      title: "Түлхүүр",
      dataIndex: "key",
      width: 260,
      render: (v) => <code style={{ fontSize: 12, fontWeight: 600 }}>{v}</code>,
    },
    {
      title: "Тайлбар",
      dataIndex: "label",
      width: 260,
      render: (v) =>
        v ? (
          <span style={{ fontSize: 13 }}>{v}</span>
        ) : (
          <span style={{ color: "#ccc" }}>—</span>
        ),
    },
    {
      title: "Утга",
      dataIndex: "value",
      render: (v) => <span style={{ fontSize: 13 }}>{v}</span>,
    },
    {
      title: "Эрэмбэ",
      dataIndex: "sortOrder",
      width: 90,
      render: (v) => <span style={{ fontSize: 12, color: "#999" }}>{v}</span>,
    },
    {
      title: "",
      width: 90,
      render: (_, r) => (
        <Space size={4}>
          <Button
            type="text"
            size="small"
            icon={<IconPencil size={15} />}
            onClick={() => {
              setEditingRow(r);
              setModalOpen(true);
            }}
          />
          <Popconfirm
            title="Устгах уу?"
            okText="Устгах"
            cancelText="Болих"
            onConfirm={() => onDelete(r.id)}
          >
            <Button
              danger
              type="text"
              size="small"
              icon={<IconTrash size={15} />}
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <section className="keywords-section">
      <PageHeader
        title="Түлхүүр үгс"
        sub="Сайт дээр харагдах текст утгууд"
        rSide={
          <Button
            type="primary"
            icon={<IconPlus size={16} />}
            onClick={() => {
              setEditingRow(null);
              setModalOpen(true);
            }}
          >
            Нэмэх
          </Button>
        }
      />

      <Input
        prefix={<SearchOutlined />}
        placeholder="Түлхүүр / тайлбар / утга хайх..."
        style={{ width: 320, marginBottom: 16 }}
        value={q}
        onChange={(e) => setQ(e.target.value)}
        allowClear
      />

      <div className="table-wrap">
        <Table
          rowKey="id"
          loading={loading}
          columns={columns}
          dataSource={filtered}
          pagination={false}
          size="middle"
        />
      </div>

      <KeywordFormModal
        open={modalOpen}
        editingRow={editingRow}
        onClose={() => setModalOpen(false)}
        onSuccess={fetchList}
      />
    </section>
  );
}
